import { Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { RestockingListTypesEnum, RestockingState } from 'src/features/restocking/RestockingTypes'
import { useSelector } from 'src/utils/store'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import * as S from './Header.styles'

interface HeaderProps {
  title: string
  goBackRoute?: string
  propertyToClear?: keyof RestockingState | (keyof RestockingState)[]
  hasBackButton?: boolean
}

const Header: React.FC<HeaderProps> = ({
  title, goBackRoute, propertyToClear, hasBackButton = true,
}): JSX.Element => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { idRestockingType } = useSelector((state) => state.restocking)
  const isRestockingFresh = idRestockingType === RestockingListTypesEnum.RESTOCKING_FRESH_AUTOMATIC

  const goBack = () => {
    if (propertyToClear) dispatch(actions.clearProperty(propertyToClear))
    if (goBackRoute) history.push(goBackRoute)
  }

  return (
    <S.Container isRestockingFresh={isRestockingFresh}>
      <Typography>{title}</Typography>
      {
        hasBackButton && (
          <ArrowBackIosNewRoundedIcon
            onClick={goBack}
            sx={{ position: 'absolute', right: '10px', cursor: 'pointer' }}
            data-testid='arrow-back-icon'
          />
        )
      }
    </S.Container>
  )
}

export default Header
